import {
  Paper,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  IconButton,
  Box,
  Tooltip
} from '@mui/material';
import { useTheme } from '@mui/material/styles';

import { Delete, Edit } from '@mui/icons-material';

// import { formatDate } from '../../../../resources/functions';
import { RewardBonuses } from '../../../../redux/slices/rewardBonusesSlice';

interface Props {
  items: RewardBonuses[];
  openDialog?: (partnerCompany: RewardBonuses) => void;
  onDelete?: (_id: string) => void;
}

const cellStyles = {
  color: '#000000',
  fontWeight: 600
};

const RewardBonusesTable = ({ items, openDialog, onDelete }: Props) => {
  const theme = useTheme();
  
  const headerCellStyle = {
    backgroundColor: theme.palette.mode === 'dark' ? '#2A2A2A' : '#F5F5F5',
    color: theme.palette.mode === 'dark' ? '#FFFFFF' : '#424242',
    fontWeight: 600
  };
  
  return (
    <TableContainer sx={{ mt: 3 }} component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell sx={headerCellStyle}>Фонове Зображення</TableCell>
            <TableCell sx={headerCellStyle}>Назва</TableCell>
            <TableCell sx={headerCellStyle}>Опис</TableCell>
            <TableCell sx={headerCellStyle}>Ліміт активацій</TableCell>
            <TableCell sx={headerCellStyle}>Кількість активацій</TableCell>
            <TableCell sx={headerCellStyle}>Активовано</TableCell>
            {/* <TableCell sx={cellStyles}>Дата створення</TableCell>
            <TableCell sx={cellStyles}>Дата оновлення</TableCell> */}
            <TableCell sx={headerCellStyle}></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {items.map(partnerCompany => {
            return (
              <TableRow hover key={partnerCompany._id}>
                <TableCell>
                  {partnerCompany.bgPhoto?.startsWith('uploads/') ? (
                    <img
                      alt='icon-img'
                      style={{ maxWidth: 150 }}
                      src={`/public/${partnerCompany.bgPhoto}`}
                    />
                  ) : (
                    'Немає логотипу'
                  )}
                </TableCell>
                <TableCell>{partnerCompany.name}</TableCell>
                <TableCell>{partnerCompany.description}</TableCell>
                <TableCell>{partnerCompany.activateLimit ?? 0}</TableCell>
                <TableCell>{partnerCompany.activateCount ?? 0}</TableCell>
                <TableCell>
                  {partnerCompany.enabled ? 'Активовано' : 'Де активовано'}
                </TableCell>
                {/* <TableCell>{formatDate(partnerCompany.createdAt)}</TableCell>
                <TableCell>{formatDate(partnerCompany.updatedAt)}</TableCell> */}
                <TableCell>
                  <Box sx={{ display: 'flex', gap: 0.5, justifyContent: 'flex-end' }}>
                    <Tooltip title='Редагувати'>
                      <IconButton
                        size='medium'
                        onClick={() => {
                          openDialog?.(partnerCompany);
                        }}
                        sx={{
                          bgcolor: theme.palette.mode === 'light' ? '#F5F5F5' : '#424242',
                          color: theme.palette.mode === 'light' ? '#616161' : '#FFF',
                          borderRadius: '8px',
                          '&:hover': { bgcolor: theme.palette.mode === 'light' ? '#E0E0E0' : '#3A3A3A' }
                        }}
                      >
                        <Edit fontSize='small' />
                      </IconButton>
                    </Tooltip>

                    <Tooltip title='Видалити'>
                      <IconButton
                        size='medium'
                        onClick={() => onDelete?.(partnerCompany._id)}
                        sx={{
                          bgcolor: theme.palette.mode === 'light' ? '#F5F5F5' : '#424242',
                          color: theme.palette.mode === 'light' ? '#616161' : '#FFF',
                          borderRadius: '8px',
                          '&:hover': { bgcolor: theme.palette.mode === 'light' ? '#E0E0E0' : '#3A3A3A' }
                        }}
                      >
                        <Delete fontSize='small' />
                      </IconButton>
                    </Tooltip>
                  </Box>
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default RewardBonusesTable;
